import type { ReactNode } from 'react';
import { Button, type ButtonProperties, DownLineIcon, Dropdown, type MenuProps } from 'ui';
import type { EventActionsView } from '../../../types';

export type EventDropdownButtonProperties = {
  dropdownOptions?: {
    button: {
      icon: ReactNode;
      text: string;
    };
    menu: MenuProps;
  };
  isAccepting: boolean;
  isRejecting: boolean;
  type?: ButtonProperties['type'];
};

type P = {
  dropdownButton: EventDropdownButtonProperties;
  view: EventActionsView;
};

const EventDropdownButton = ({ dropdownButton, view }: P) => {
  const { dropdownOptions, isAccepting, isRejecting } = dropdownButton;

  if (view === 'detail' || !dropdownOptions) {
    return null;
  }

  return (
    <Dropdown menu={dropdownOptions.menu} trigger={['click']}>
      <Button
        icon={dropdownOptions.button.icon}
        loading={isAccepting || isRejecting}
        onClick={(onClickEvent) => {
          onClickEvent.preventDefault();
        }}
        size="small"
        type={dropdownButton.type}
      >
        {dropdownOptions.button.text}
        <DownLineIcon />
      </Button>
    </Dropdown>
  );
};

export default EventDropdownButton;
